import { cn } from '@/utils/cn';
import * as React from 'react';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  numeric?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, numeric, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-12 w-full rounded-sm border border-input bg-background px-4 py-3 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-colors',
          error && 'border-error-800 focus-visible:ring-error-800',
          numeric && 'font-mono text-right tabular-nums',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

// Industrial styled input with larger touch target
const InputIndustrial = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, numeric, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex min-h-touch w-full rounded-sm border border-input bg-background px-4 py-3 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:shadow-[0_0_0_2px_rgba(255,107,0,0.2)] disabled:cursor-not-allowed disabled:opacity-50 transition-all',
          error && 'border-error-800 focus-visible:shadow-[0_0_0_2px_rgba(198,40,40,0.2)]',
          numeric && 'font-mono text-right tabular-nums',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
InputIndustrial.displayName = 'InputIndustrial';

export { Input,InputIndustrial };
